import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

export default class MotivosRechazoViewController {
  constructor() {
    this.motivosRechazo = [];
    this.loading = false;
    this.error = null;
    this.sortField = null;
    this.sortDirection = 'asc';
    this.currentPage = 1;
    this.itemsPerPage = 10;
  }

  // Inicialización del controlador
  initialize() {
    this.loadMotivosRechazo();
  }

  // Cargar motivos de rechazo
  async loadMotivosRechazo() {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await post(getApiUrl('/api/MotivoRechazo/listar'), {});
      this.motivosRechazo = response.data || [];
    } catch (error) {
      console.error('Error al cargar motivos de rechazo:', error);
      this.error = 'No se pudieron cargar los motivos de rechazo. Por favor, intente nuevamente.';
    } finally {
      this.loading = false;
    }
  }

  // Recargar motivos de rechazo
  async reloadMotivosRechazo() {
    await this.loadMotivosRechazo();
  }

  // Eliminar motivo de rechazo
  async deleteMotivoRechazo(motivoRechazoId) {
    try {
      const deleteData = { IdMotivoRechazo: motivoRechazoId };
      const response = await post(getApiUrl('/api/MotivoRechazo/borrar'), deleteData, {}, false);
      
      return {
        success: response.data.Number > 0,
        message: response.data.Number > 0 
          ? 'Motivo de rechazo eliminado correctamente.' 
          : 'No se pudo eliminar el motivo de rechazo.',
        response
      };
    } catch (error) {
      console.error('Error al eliminar motivo de rechazo:', error);
      return {
        success: false,
        message: 'No se pudo eliminar el motivo de rechazo. Por favor, intente nuevamente.',
        error
      };
    }
  }

  // Ordenamiento
  sort(field) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
  }

  // Obtener icono de ordenamiento
  sortIcon(field) {
    if (this.sortField !== field) {
      return 'bi bi-arrow-down-up';
    }
    return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
  }

  // Datos ordenados
  get sortedData() {
    if (!this.sortField) {
      return this.motivosRechazo;
    }

    return [...this.motivosRechazo].sort((a, b) => {
      let aVal = a[this.sortField];
      let bVal = b[this.sortField];

      // Manejar fechas
      if (this.sortField === 'FechaCreacion') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }

      // Manejar strings
      if (typeof aVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (aVal < bVal) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (aVal > bVal) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  // Datos paginados
  get paginatedData() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.sortedData.slice(start, end);
  }

  // Total de páginas
  get totalPages() {
    return Math.ceil(this.motivosRechazo.length / this.itemsPerPage);
  }

  // Cambiar página
  changePage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
}